import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Accordion, Card, Col, Container, Form, Image, InputGroup, Row } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import { useCookies } from "react-cookie";
import "../general.css";
import CrossWord from './cossword';
import Legend from './Legend';
import "./home.css";
import Dictionary from './dictionary';
import Puzzle from './puzzle';
import Answer from './answer';
import Winner from './winner';

const Home = ({ en }) => {
  const [cookies, setCookie, removeCookie] = useCookies();
  const [spAns, setSpAns] = useState(["", "", "", "", ""]);
  useEffect(() => {
    if (cookies.spAns) {
      setSpAns(cookies.spAns);
    }
  }, []
  );

  // フォーム内容が更新されたとき
  const handlerChange = (e, n) => {
    let ans = spAns;
    ans[n] = e.target.value;
    setSpAns(ans);
    setCookie("spAns", ans, { maxAge: 2592000 });
  };
  // const handlerDelete = () => {
  //   removeCookie("spAns");
  // };
  // const handleSubmit = () => {
  //   setCookie("spAns", spAns);
  // };

  return (
    <>
      <header className='mt-1'>
        <div style={{ backgroundImage: 'url("/img/header.png")' }} className='mb-3'></div>
        <h1>{en ? "Prophet Abraham's Biography" : "『預言者伝』"}</h1>
        <h4>{en ? (<>Journey for searching water<br />becomes a Legend……</>) : "～水なき旅人 そして伝説へ～"}</h4>
        <div style={{ backgroundImage: 'url("/img/header.png")', transform: "scale(1,-1)" }} className='mt-3'></div>
      </header>
      <div className='m-3'>
        <div>
          {/* <hr /> */}
          {en ?
            (<>
              <p>You have lost all your water in Arabian desert.</p>
              <p>There is large desert, so you cannot escape from here.<br />Of course there is no water.</p>
              <p>You brought “Historical book”, “Dictionary”, “Crossword”, “Puzzle”, “Map”.<br />Use these items efficiently and survive from there intense climates.</p>
              <p>If you understand EVERYTHING and go to the reception, something good will happen to you...</p>
              <p>Don't search anything about this legend because Internet isn't produced then.</p>
            </>
            ) : (
              <>
                <p>
                  あなたはサウジアラビアの砂漠で、<br />持っていた水を切らしてしまった。
                </p>
                <p>ここは見渡す限りに広がる砂漠だ。<br />水など存在しない。</p>
                <p>
                  所持している「書物」「辞書」「クロスワード」「謎」「マップ」を活用して、なんとか生き延びてくれ。
                </p>
                <p>もしも<b>”すべて”</b>がわかったら、<br />受付に行くと何かいいことがあるかもな。</p>
                <br />
                <p>それと、インターネット検索は禁じる。<br />砂漠にインターネットなど存在しないぞ。</p>

              </>
            )}
          {/* <hr /> */}
        </div>

        <Accordion className='mt-5' defaultActiveKey="">
          <Accordion.Item>
            <Accordion.Header>{en ? "Historical Book" : "書物"}</Accordion.Header>
            <Accordion.Body className='background-image-position' style={{ backgroundImage: 'url("/img/paper.jpg")' }}>
              <Legend en={en} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <Accordion className='mt-3' defaultActiveKey="">
          <Accordion.Item>
            <Accordion.Header>{en ? "Dictionary" : "辞書"}</Accordion.Header>
            <Accordion.Body>
              <Dictionary en={en} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <Accordion className='mt-3' defaultActiveKey="">
          <Accordion.Item>
            <Accordion.Header>{en ? "Crossword" : "クロスワード"}</Accordion.Header>
            <Accordion.Body>
              <CrossWord en={en} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <Accordion className='mt-3' defaultActiveKey="">
          <Accordion.Item>
            <Accordion.Header>{en ? "Puzzle" : "謎"}</Accordion.Header>
            <Accordion.Body>
              <Puzzle en={en} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <Accordion className='mt-3' defaultActiveKey="">
          <Accordion.Item>
            <Accordion.Header>{en ? "Map" : "マップ"}</Accordion.Header>
            <Accordion.Body>
              {cookies.dicClear ? (
                <Image src={en ? '/img/map2_en.png' : '/img/map2.png'} width="100%" />
              ) : (
                <Image src={en ? '/img/map_en.png' : '/img/map.png'} width="100%" />
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

      </div>

      <Answer en={en} />
      <Winner en={en} />
    </>
  )
}

export default Home;
